import {
  GET_CARRIER_LIST_SUCCESS,
  SET_CARRIER_LIST_LOADING,
  GET_CARRIER_DETAILS_ERROR,
  GET_CARRIER_DETAILS_SUCCESS,
  SET_CARRIER_DETAILS_LOADING,
  RESET_CARRIER_DETAILS,
  CREATE_CARRIER_SUCCESS,
  UPDATE_CARRIER_DETAILS_SUCCESS,
  REMOVE_CARRIER_SUCCESS,
  RESET_CARRIER_LIST,
} from '../constants/ActionTypes';

const INIT_STATE = {
  carriers: {
    list: [],
    pageCount: 0,
    recentlyAdded: [],
  },
  details: null,
  loadingList: false,
  loadingDetails: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_CARRIER_LIST_SUCCESS:
      return {
        ...state,
        carriers: {
          ...state.carriers,
          list: [...state.carriers.list, ...action.payload.carriers],
          pageCount: action.payload.pageCount,
        },
      };
    case SET_CARRIER_LIST_LOADING:
      return {
        ...state,
        loadingList: action.payload.isLoading,
      };
    case GET_CARRIER_DETAILS_ERROR:
      return {
        ...state,
        details: null,
      };
    case GET_CARRIER_DETAILS_SUCCESS:
      return {
        ...state,
        details: action.payload.carrier,
      };
    case SET_CARRIER_DETAILS_LOADING:
      return {
        ...state,
        loadingDetails: action.payload.isLoading,
      };
    case RESET_CARRIER_DETAILS:
      return {
        ...state,
        details: null,
      };
    case CREATE_CARRIER_SUCCESS: {
      const recentlyAddedCarriers = [action.payload.carrier, ...state.carriers.recentlyAdded];
      return {
        ...state,
        carriers: {
          ...state.carriers,
          recentlyAdded: recentlyAddedCarriers,
        },
      };
    }
    case UPDATE_CARRIER_DETAILS_SUCCESS: {
      const { carrier } = action.payload;

      return {
        ...state,
        details: state.details ? carrier : null,
        carriers: {
          ...state.carriers,
          list: state.carriers.list.map(
            item =>
              item.id === carrier.id
                ? {
                    id: carrier.id,
                    name: carrier.name,
                    pathToLogo: carrier.pathToLogo,
                  }
                : item,
          ),
          recentlyAdded: state.carriers.recentlyAdded.map(
            item =>
              item.id === carrier.id
                ? {
                    address: carrier.address,
                    contactPerson: carrier.contactPerson,
                    email: carrier.email,
                    id: carrier.id,
                    name: carrier.name,
                    newCarrier: true,
                    pathToLogo: carrier.pathToLogo,
                    phoneNumber: carrier.phoneNumber,
                  }
                : item,
          ),
        },
      };
    }
    case REMOVE_CARRIER_SUCCESS: {
      const { carrierId } = action.payload;
      const { list, recentlyAdded } = state.carriers;
      const isRecentlyAdded = recentlyAdded.findIndex(carrier => carrier.id === carrierId) > -1;

      return {
        ...state,
        carriers: {
          ...state.carriers,
          list: isRecentlyAdded ? list : list.filter(item => item.id !== carrierId),
          recentlyAdded: isRecentlyAdded
            ? recentlyAdded.filter(item => item.id !== carrierId)
            : recentlyAdded,
        },
        details: null,
      };
    }
    case RESET_CARRIER_LIST: {
      return {
        ...state,
        carriers: {
          ...state.carriers,
          list: [],
          pageCount: 0,
          recentlyAdded: [],
        },
      };
    }
    default:
      return state;
  }
};
